import { all } from 'redux-saga/effects';
import { AuthSaga } from './auth/auth.saga';
import { DepositSaga } from './deposit/deposit.saga';
import { PresaleSaga } from './presale/presale.saga';
import { SupportSaga } from './support/support.saga';
import { TransactionSaga } from './transaction/transaction.saga';
import { UserSaga } from './user/user.saga';
import { WhitelistSaga } from './whitelist/whitelist.saga';
import { WithdrawSaga } from './withdraw/withdraw.saga';

export default function* rootSaga() {
    yield all([
        AuthSaga(),
        UserSaga(),
        DepositSaga(),
        WithdrawSaga(),
        WhitelistSaga(),
        TransactionSaga(),
        SupportSaga(),
        PresaleSaga()
    ]);
}